export let GT_Seam_Allowance_Quality = [
  "KIO_QUALITY_LEVEL1",
  "KIO_QUALITY_LEVEL2",
  "KIO_QUALITY_LEVEL3",
  "KIO_QUALITY_LEVEL4",
];

export let GT_Labels = [
  "IFGF_LINE_INTERNAL_TOOL_CUT",
  "IFGF_LINE_EXTERNAL_TOOL_SEAM",
  "IFGF_LINE_INTERNAL_TOOL_SEAM",
  "IFGF_LINE_TOOL_PLOT",
  "IFGF_LINE_TOOL_CANAL",
  "IFGF_LINE_TOOL_SUSPHOLE",
  "IFGF_LINE_TOOL_AXIS",
  "IFGF_LINE_TOOL_GRAINLINE",
  "IFGF_LINE_TOOL_COMMENT",
  "IFGF_LINE_TOOL_SYMETRY",
  "IFGF_LINE_TOOL_CROSSLINE",
  "KIO_SEPARATOR",
  "KIO_QUALITY_LEVEL1",
  "KIO_QUALITY_LEVEL2",
  "KIO_QUALITY_LEVEL3",
  "KIO_QUALITY_LEVEL4",
  "KIO_MARK_TOOL_TYP1",
  "KIO_MARK_TOOL_TYP2",
  "KIO_MARK_TOOL_TYP3",
  "KIO_MARK_TOOL_TYP4",
  "KIO_MOTIF_TOOL",
  "KIO_NO_TOOL",
];

export let GT_Notch = ["21", "22", "23", "24"];
export let GT_Direction_Notch = ["INTERNAL", "EXTERNAL"];

export let GT_Params = [
  "GT_LABEL_A",
  "GT_LABEL_B",
  "GT_LABEL_C",
  "GT_LABEL_D",
  "GT_LABEL_E",
  "GT_LABEL_F",
  "GT_LABEL_G",
  "GT_LABEL_H",
  "GT_LABEL_I",
  "GT_LABEL_J",
  "GT_LABEL_K",
  "GT_LABEL_L",
  "GT_LABEL_M",
  "GT_LABEL_N",
  "GT_LABEL_O",
  "GT_LABEL_P",
  "GT_LABEL_Q",
  "GT_LABEL_R",
  "GT_LABEL_S",
  "GT_LABEL_T",
  "GT_LABEL_U",
  "GT_LABEL_V",
  "GT_LABEL_W",
  "GT_LABEL_X",
  "GT_LABEL_Y",
  "GT_LABEL_Z",
  "GT_LABEL_0",
  "GT_LABEL_1",
  "GT_LABEL_2",
  "GT_LABEL_3",
  "GT_LABEL_4",
  "GT_LABEL_5",
  "GT_LABEL_6",
  "GT_LABEL_7",
  "GT_LABEL_8",
  "GT_LABEL_9",
  "GT_LABEL_10",
  "GT_LABEL_11",
  "GT_LABEL_12",
  "GT_LABEL_13",
  "GT_LABEL_14",
  "GT_LABEL_15",
  "GT_LABEL_16",
  "SEAM_ALLOWANCE_VALUE",
  "SEAM_ALLOWANCE_QUALITY",
  "COMPUTE_QUALITY_ZONE",
  "AUTO_CLOSE_QUALITY_ZONE_DISTANCE",
  "GT_NOTCH_AUTO_ORIENTE_1",
  "GT_NOTCH_AUTO_ORIENTE_2",
  "GT_NOTCH_AUTO_ORIENTE_3",
  "GT_NOTCH_AUTO_ORIENTE_4",
  "GT_NOTCH_AUTO_ORIENTE_5",
  "GT_DIRECTION_NOTCH_AUTO_ORIENTE_1",
  "GT_DIRECTION_NOTCH_AUTO_ORIENTE_2",
  "GT_DIRECTION_NOTCH_AUTO_ORIENTE_3",
  "GT_DIRECTION_NOTCH_AUTO_ORIENTE_4",
  "GT_DIRECTION_NOTCH_AUTO_ORIENTE_5",
  "GT_NOTCH_ORIENTE_1",
  "GT_NOTCH_ORIENTE_2",
  "GT_NOTCH_ORIENTE_3",
  "GT_NOTCH_ORIENTE_4",
  "GT_NOTCH_ORIENTE_5",
  "GT_DIRECTION_NOTCH_ORIENTE_1",
  "GT_DIRECTION_NOTCH_ORIENTE_2",
  "GT_DIRECTION_NOTCH_ORIENTE_3",
  "GT_DIRECTION_NOTCH_ORIENTE_4",
  "GT_DIRECTION_NOTCH_ORIENTE_5",
];
export let GT_ParamsName_00 = [
  "GT_LABEL",
  "SEAM_ALLOWANCE_VALUE",
  "SEAM_ALLOWANCE_QUALITY",
  "COMPUTE_QUALITY_ZONE",
  "AUTO_CLOSE_QUALITY_ZONE_DISTANCE",
  "GT_NOTCH_AUTO_ORIENTE",
  "GT_DIRECTION_NOTCH_AUTO_ORIENTE",
  "GT_NOTCH_ORIENTE",
  "GT_DIRECTION_NOTCH_ORIENTE",
];

export let GT_ParamsName_01 = [
  "GT_LABEL",
  "SEAM_ALLOWANCE_VALUE",
  "SEAM_ALLOWANCE_QUALITY",
  "COMPUTE_QUALITY_ZONE",
  "AUTO_CLOSE_QUALITY_ZONE_DISTANCE",
  "GT_STANDARD_NOTCH",
  "EXTERNAL_STANDARD_NOTCH",
  "GT_ANGLED_NOTCH",
  "EXTERNAL_ANGLED_NOTCH",
];
export let GT_ParamsName = [
  "GT_LABEL",
  "SEAM_ALLOWANCE_VALUE",
  "SEAM_ALLOWANCE_QUALITY",
  "COMPUTE_QUALITY_ZONE",
  "AUTO_CLOSE_QUALITY_ZONE_DISTANCE",
  "NOTCH",
  "NOTCH_IS_EXTERNAL",
  "FABRIC_REPEAT_X",
  "FABRIC_REPEAT_Y",
];
/*
 User Story S-120681
Se trata de cambiar unos textos en la interfaz de usuario pero teniendo en cuenta que en el 
fichero .json de configuracion del conversor no van a cambiar por compatibilidad con las configuraciones existentes:
GT_NOTCH_AUTO_ORIENTE  se cambia por GT_STANDARD_NOTCH
GT_NOTCH_ORIENTE se cambia por GT_ANGLED_NOTCH
GT_DIRECTION_NOTCH_AUTO_ORIENTE se cambia por EXTERNAL_STANDARD_NOTCH
GT_DIRECTION_NOTCH_ORIENTE se cambia por EXTERNAL_ANGLED_NOTCH

20/01/2022 volvemos atras, anotamos los pasos para revertirlo:
1.- en este fichero, cambiamo slos nombre GT_ParamsName_00 y GT_ParamsName
2.- converters.js   comentamos las llamadas a ConvertFromStoredNotchToPresentationNotch y ConvertFromPresentationNotchToStoredNotch
3.-
cambiar
 GT_STANDARD_NOTCH - > GT_NOTCH_AUTO_ORIENTE
 GT_ANGLED_NOTCH ---> GT_NOTCH_ORIENTE 
EXTERNAL_STANDARD_NOTCH   >  GT_DIRECTION_NOTCH_AUTO_ORIENTE
EXTERNAL_ANGLED_NOTCH  > GT_DIRECTION_NOTCH_ORIENTE

en ConverterConfig.js
    handleAdd

en ConfigParam.js al comienzo del render (dejo comentados los valores actuales)
y en la funcion SetParamsModFromParamsName
 */

export let GT_Params_NOTCH = [
  "1",
  "2",
  "3",
  "4",
  "5",
  "6",
  "7",
  "8",
  "9",
  "10",
  "11",
  "12",
  "13",
  "14",
  "15",
  "16",
  "17",
  "18",
  "19",
  "20",
];

export let GT_Params_NOTCH_IS_EXTERNAL = [
  "1",
  "2",
  "3",
  "4",
  "5",
  "6",
  "7",
  "8",
  "9",
  "10",
  "11",
  "12",
  "13",
  "14",
  "15",
  "16",
  "17",
  "18",
  "19",
  "20",
];

export let GT_Params_LABEL = [
  "A",
  "B",
  "C",
  "D",
  "E",
  "F",
  "G",
  "H",
  "I",
  "J",
  "K",
  "L",
  "M",
  "N",
  "O",
  "P",
  "Q",
  "R",
  "S",
  "T",
  "U",
  "V",
  "W",
  "X",
  "Y",
  "Z",
  "0",
  "1",
  "2",
  "3",
  "4",
  "5",
  "6",
  "7",
  "8",
  "9",
  "10",
  "11",
  "12",
  "13",
  "14",
  "15",
  "16",
];
export let GT_Params_STANDARD_NOTCH = [
  "1",
  "2",
  "3",
  "4",
  "5",
  "6",
  "7",
  "8",
  "9",
  "10",
  "11",
  "12",
  "13",
  "14",
  "15",
  "16",
  "17",
  "18",
  "19",
  "20",
];
export let GT_Params_DIRECTION_STANDARD_NOTCH = [
  "1",
  "2",
  "3",
  "4",
  "5",
  "6",
  "7",
  "8",
  "9",
  "10",
  "11",
  "12",
  "13",
  "14",
  "15",
  "16",
  "17",
  "18",
  "19",
  "20",
];
export let GT_Params_ANGLED_NOTCH = [
  "1",
  "2",
  "3",
  "4",
  "5",
  "6",
  "7",
  "8",
  "9",
  "10",
  "11",
  "12",
  "13",
  "14",
  "15",
  "16",
  "17",
  "18",
  "19",
  "20",
];
export let GT_Params_DIRECTION_ANGLED_NOTCH = [
  "1",
  "2",
  "3",
  "4",
  "5",
  "6",
  "7",
  "8",
  "9",
  "10",
  "11",
  "12",
  "13",
  "14",
  "15",
  "16",
  "17",
  "18",
  "19",
  "20",
];
export let GT_Params_VACIO = [];

export let ConvertTypes = [];
export let ConvertTypesOut = [];

/*
s-116208
--------------
ASTM IN	          aama_astm
AAMA IN	          aama_astm
DXF Extended IN 	dxf_extended
DXF Extended OUT	dxf_extended
GT IN	            accumark
MDLV7 OUT         mdl_V7
-----------------------------------------------------
LSM                     subscriptionPCONV_LSM
export let ConvertTypes = ["accumark", "aama_astm"];
export let ConvertTypesOut = [ "mdl_V7"];
-----------------------------------------------------
Subscription                     subscriptionPCONV_SUBSCRIPTIONS
export let ConvertTypes = ["accumark", "aama_astm"];
export let ConvertTypesOut = [ "mdl_V7"];
-----------------------------------------------------
Quick/Flex                      subscriptionQuickNext, subscriptionFlexOffer
export let ConvertTypes = ["accumark", "aama_astm"];
export let ConvertTypesOut = ["aama_astm"];
-----------------------------------------------------
Fashion&Furni On Demand                        subscriptionMTO_FashionOnDemmand ,subscriptionMTO_FurnitureOnDemmand ,subscriptionMTC_FashionOnDemmand,
subscriptionMTC_FurnitureOnDemmand,subscriptionOD_FashionOnDemmand ,subscriptionOD_FurnitureOnDemmand, subscriptionMTM_FashionOnDemmand,subscriptionMTM_FurnitureOnDemmand 
export let ConvertTypes = ["accumark", "aama_astm"];
export let ConvertTypesOut = ["aama_astm"];


*/
